/**
 * Fotos de producto.
 *
 * Muchos productos del catálogo no tienen foto cargada, así que la petición
 * termina en 404 y la ficha cae en el logo. Sin memoria, ese 404 se repite en
 * cada render y en cada navegación, y se ve el parpadeo del placeholder.
 *
 * Guardamos los SKU que ya fallaron para no volver a pedirlos durante la
 * sesión. Es a propósito un módulo con estado: se comparte entre la grilla y la
 * ficha, y se vacía solo al recargar la página, que es cuando tiene sentido
 * reintentar por si subieron la imagen.
 */
const missingImages = new Set();

export const productImageUrl = (sku) =>
	`${process.env.GATSBY_WORDPRESS_BASE_URL}/wp-content/uploads/product-images/${sku}.jpg`;

export const hasKnownMissingImage = (sku) => missingImages.has(sku);

export const rememberMissingImage = (sku) => missingImages.add(sku);
